<template>
  <div>
    <div class="page">
      <HeaderBlock />
      <div
        v-if="pageData?.attributes?.pageContent"
        class="wrapper"
        v-html="pageData.attributes.pageContent"
      />
    </div>
    <FooterBlock />
  </div>
</template>

<script lang="ts" setup>
const pageData = await getOferta()
</script>

<style lang="scss" scoped>
.page {
  padding: 120px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background: #f5f6fb;
  color: $color-dark-gray;
  min-height: 100dvh;
  width: 100%;
  overflow: hidden;
  h1 {
    text-align: center;
  }
  .wrapper {
    max-width: 820px;
    width: 100%;
    margin: 0 auto;
  }
}
:global(.table) {
  width: 100%;
  overflow: scroll !important;
}
:global(p, ul, figure, img) {
  margin-bottom: 0.5rem;
}
:global(table) {
  width: 100%;
  border-collapse: collapse;
  overflow: scroll;
}
:global(tr td) {
  padding: 10px;
  border: 1px solid black;
}
</style>
